export default __webpack_public_path__ + "static/media/sadem2.0c75fce1.jpg";